import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  tableSort: {
    // backgroundColor: '#919',
    "& svg": {
      // backgroundColor: '#911',
      color: "#1D1F20 !important",
    },
  },
  headerRow: {
    "& th:first-child": {
      borderTopLeftRadius: 6,
    },
    "& th:last-child": {
      borderTopLeftRadius: 6,
    },
  },
  dataTableDiv: {
    overflow: 'scroll',
    background: "#FFF",
    display: "flex",
    marginTop: 16,
    paddingBottom: 35,
    '& .infinite-scroll-component': {
      overflow:' hidden !important',
    }
  },

  tableBody: {
    backgroundColor: "#fff",
    border: "none",
    "& .MuiTableCell-root": {
      border: "none",
      backgroundColor: "transparent",
      "& .css-xemq8y-MuiTableRow-root:nth-of-type(odd)": {
        backgroundColor: "transparent",
      },
    },
  },
  headerCheckbox: {
    padding: 0,
    width: 18,
    height: 18,
    marginRight: 6,
  },
  customCheckbox: {
    padding: 0,
    width: 18,
    height: 18,
  },
});
